import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Inputs from './components/Inputs';
import Results from './components/Results';
import { calculateResults } from './utils/calculations';

function App() {
  const [inputs, setInputs] = useState({
    companySize: 250,
    avgSalary: 65000,
    replaceTime: 6,
    revenuePerEmployee: 180000,
    retentionUplift: 12,
    turnoverRate: 18,
    costPerHire: 8000,
    absenteeism: 3.5,
    programCost: 120000,
    timeToFillReduction: 30,
  });

  const results = calculateResults(inputs);

  const handleInputChange = (name, value) => {
    setInputs(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const randomizeDemo = () => {
    setInputs({
      companySize: Math.floor(Math.random() * 500) + 100,
      avgSalary: Math.floor(Math.random() * 50000) + 40000,
      replaceTime: Math.floor(Math.random() * 8) + 4,
      revenuePerEmployee: Math.floor(Math.random() * 100000) + 100000,
      retentionUplift: Math.floor(Math.random() * 20) + 5,
      turnoverRate: Math.floor(Math.random() * 20) + 10,
      costPerHire: Math.floor(Math.random() * 5000) + 5000,
      absenteeism: parseFloat((Math.random() * 5 + 2).toFixed(1)),
      programCost: Math.floor(Math.random() * 100000) + 50000,
      timeToFillReduction: Math.floor(Math.random() * 40) + 20,
    });
  };

  const copyURL = () => {
    const url = window.location.href;
    navigator.clipboard.writeText(url);
    alert('URL copied to clipboard!');
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="App">
      <Header />
      <div className="main-content">
        <div className="container">
          <div className="inputs-section">
            <Inputs
              inputs={inputs}
              onInputChange={handleInputChange}
              onRandomize={randomizeDemo}
              onCopyURL={copyURL}
            />
          </div>
          <div className="results-section">
            <Results
              results={results}
              inputs={inputs}
              onScrollToTop={scrollToTop}
            />
          </div>
        </div>
      </div>

    </div>
  );
}

export default App;

